module.exports = "/images/constant contact.svg?0e4301d1d2643121db6b68195578ac44";